import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ChevronDown, ChevronRight, FileWarning, FileUp } from "lucide-react";
import { api, extractErrorMessage } from "@/lib/api";
import { uploadPersonnelDoc } from "./PersonnelDocsField";

const Row = ({ p, kind, onUploaded }) => (
  <div className="flex items-center gap-2 bg-white border border-rose-200 rounded-md px-2 py-1.5" data-testid={`missing-doc-${kind}-${p.sicil_no}`}>
    <div className="flex-1 min-w-0">
      <div className="text-sm font-semibold text-slate-900">{p.ad_soyad}</div>
      <div className="text-[11px] text-slate-500">{p.pozisyon} · {kind === "ise_giris" ? `giriş ${p.ise_baslama_tarihi || "—"}` : `çıkış ${p.ise_cikis_tarihi || "—"}`}</div>
    </div>
    <label className="inline-flex items-center gap-1 px-2 py-1 bg-rose-700 hover:bg-rose-800 text-white rounded text-xs font-semibold cursor-pointer">
      <FileUp size={12} /> Yükle
      <input type="file" accept=".pdf,.jpg,.jpeg,.png" className="hidden" data-testid={`missing-doc-upload-${kind}-${p.sicil_no}`}
        onChange={async (e) => {
          const f = e.target.files?.[0]; e.target.value = "";
          if (!f) return;
          try { await uploadPersonnelDoc(p.id, kind, f); toast.success(`${p.ad_soyad} · bildirge yüklendi`); onUploaded(); }
          catch (err) { toast.error(extractErrorMessage(err, "Yüklenemedi")); }
        }} />
    </label>
  </div>
);

export const MissingDocsPanel = ({ refreshKey }) => {
  const [data, setData] = useState({ giris: [], cikis: [] });
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("ise_giris");
  const load = () => api.get("/personnel/missing-documents").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, [refreshKey]);
  const total = data.giris.length + data.cikis.length;
  if (!total) return null;
  const list = tab === "ise_giris" ? data.giris : data.cikis;
  const tabBtn = (k, label, n) => (
    <button type="button" onClick={() => setTab(k)} data-testid={`missing-doc-tab-${k}`}
      className={`px-2.5 py-1 rounded text-xs font-semibold ${tab === k ? "bg-rose-700 text-white" : "bg-white border border-rose-200 text-rose-800"}`}>{label} ({n})</button>
  );

  return (
    <div className="mx-4 md:mx-5 mt-3 border border-rose-300 bg-rose-50 rounded-lg" data-testid="missing-docs-panel">
      <button type="button" onClick={() => setOpen(!open)} data-testid="missing-docs-toggle"
        className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm font-semibold text-rose-900">
        <FileWarning size={15} className="text-rose-700" />
        <span data-testid="missing-docs-count">Eksik SGK bildirgesi · {data.giris.length} işe giriş, {data.cikis.length} işten çıkış</span>
        <span className="ml-auto">{open ? <ChevronDown size={15} /> : <ChevronRight size={15} />}</span>
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-2">
          <div className="flex gap-1.5">
            {tabBtn("ise_giris", "İşe giriş bildirgesi yok (aktif)", data.giris.length)}
            {tabBtn("ise_cikis", "İşten çıkış bildirgesi yok (ayrılan)", data.cikis.length)}
          </div>
          <div className="space-y-1.5 max-h-80 overflow-y-auto">
            {list.length ? list.map((p) => <Row key={p.id} p={p} kind={tab} onUploaded={load} />)
              : <div className="text-xs text-emerald-700 py-2">Bu listede eksik yok.</div>}
          </div>
        </div>
      )}
    </div>
  );
};
